/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LogRequest } from '../models/LogRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LogsService {
    /**
     * Post Log
     * Post a log message to the server logs.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postLogInfo(
        requestBody: LogRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/logs/info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Log Debug
     * Post a debug log message to the server logs.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postLogDebug(
        requestBody: LogRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/logs/debug',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Log Warn
     * Post a warning log message to the server logs.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postLogWarn(
        requestBody: LogRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/logs/warn',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Log Warning
     * Post a warning log message to the server logs.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postLogWarning(
        requestBody: LogRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/logs/warning',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Log Error
     * Post an error log message to the server logs.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postLogError(
        requestBody: LogRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/logs/error',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Health
     * Check the health of the logging service.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getHealth(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/logs/health',
        });
    }
}
